<div
  class="best-price best-price--not-clickable"
  appClickOutside
  [ngClass]="{
    'best-price--opened': isOpened,
    'best-price--visible': isVisible
  }"
>
  <ng-container>
    <div #bestPriceWrap class="best-price__wrap">
      <div
        class="best-price__label"
        [ngClass]="{ 'best-price__label-opened': isOpened }"
        [ngStyle]="{ minWidth: !isMobile ? bestPriceWrap.clientHeight - bestPriceBtn.clientHeight + 'px' : '' }"
      >
        <div class="best-price__label-title" (click)="!isMobile ? openBanner() : null">
          <i class="fa-solid fa-tags best-price__icon"></i>
          {{ 'best-price-main-title' | translate }}
        </div>
        <ng-template *ngIf="isMobile" [ngTemplateOutlet]="offers"> </ng-template>
      </div>
      <button #bestPriceBtn type="button" class="button best-price__btn" (click)="openBanner()">
        <i
          *ngIf="isMobile"
          [ngClass]="{
            'fa-chevron-left best-price__icon-arrow best-price__icon-arrow--opened': isOpened,
            'fa-solid fa-tags': !isOpened
          }"
        ></i>
        <i
          *ngIf="!isMobile"
          class="fa-chevron-left best-price__icon-arrow"
          [ngClass]="{ 'best-price__icon-arrow--opened': isOpened }"
        ></i>
      </button>
    </div>
  </ng-container>
  <ng-template *ngIf="!isMobile" [ngTemplateOutlet]="offers"> </ng-template>
</div>

<ng-template #offers>
  <div class="best-price__offers">
    <app-best-price-tooltip
      [bannerType]="true"
      [adults]="adults"
      [children]="children"
      [currentLang]="currentLang"
      [isVisible]="true"
      [amount]="amount"
      [currency]="currency"
      [bookingLengthInDays]="bookingLengthInDays"
      [suiteFilterLimitInDays]="suiteFilterLimitInDays"
      [checkin]="checkin"
      [checkout]="checkout"
      (closeBanner)="closeBanner()"
    />
  </div>
</ng-template>
